
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie-policy",
      function () {
        return require("private-next-pages/cookie-policy/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookie-policy"])
      });
    }
  